/* noted. — Skipstone experience layer, v7.3.
   Header "catch": pinned and transparent over the hero for the first CATCH px
   of scroll; past that the page catches it and carries it off in EXACT
   lockstep with the scroll. No independent animation, no mid-page reveal, no
   background change — the header only exists near the top, always
   transparent. Scrolling back up re-delivers it in reverse.
   v7.2: NO requestAnimationFrame — rAF stalls in occluded windows and a
   pending frame wedges any ticking flag (learned the hard way in round 4).
   The per-scroll work is a few reads and one transform write; it runs
   directly in the passive scroll handler. Node re-queried every call so a
   section re-render can't strand the transform on a detached node.
   v7.3: also engages on pages WITHOUT a hero when the brand snippet marks
   the document (data-skipstone-clear="1") — e.g. the Wines page, which
   opens straight on the Papyrus flourish block pulled up under the header. */
(function () {
  var CATCH = 140; // free scroll before the page catches the header

  function init() {
    var main = document.getElementById('main');
    var sec = document.querySelector('.shopify-section--header');
    if (!main || !sec) return;
    var marked = document.documentElement.getAttribute('data-skipstone-clear') === '1';
    if (!main.querySelector('[allow-transparent-header]') && !marked) return;

    document.documentElement.classList.add('skipstone-clear-header');
    document.documentElement.classList.remove('skipstone-header-scrolled');

    function update() {
      var s = document.querySelector('.shopify-section--header');
      if (!s) return;
      var y = Math.max(0, window.scrollY || 0);
      var h = s.offsetHeight || 0;
      var carried = Math.min(Math.max(y - CATCH, 0), h + 12);
      var t = carried > 0 ? 'translate3d(0, ' + -carried + 'px, 0)' : '';
      if (s.style.transform !== t) s.style.transform = t;

      if (carried < h) {
        var probeY = h * 0.6;
        var sections = main.querySelectorAll('.shopify-section');
        var tone = '68 68 68';
        for (var i = 0; i < sections.length; i++) {
          var r = sections[i].getBoundingClientRect();
          if (r.top <= probeY && r.bottom > probeY) {
            if (sections[i].querySelector('.color-scheme--with-image-overlay, .content-over-media')) {
              tone = '255 255 255';
            }
            break;
          }
        }
        document.documentElement.style.setProperty('--skipstone-header-rgb', tone);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('visibilitychange', update);
    setInterval(update, 800); // keeps state honest if an event is ever swallowed
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
